import { getAnonymizedAwareDisplayName } from "helpers";
import { UserLookupModel } from "models/UserLookupModel";
import { UserModel } from "models/UserModel";
import { useTranslations } from "providers";

import { SbbPersonaLink } from "./SbbPersonaLink";

export interface PersonaProps {
  user: UserModel | UserLookupModel;
  size?: number;
  title?: string;
  subTitle?: string;
  disabled?: boolean;
  hideUrl?: boolean;
}
export const Persona: React.FC<PersonaProps> = ({ user, size, title, subTitle, disabled, hideUrl }) => {
  const i18n = useTranslations();
  const defaultTitle = getAnonymizedAwareDisplayName(user.displayNameWithOrganisationUnit, i18n);

  return (
    <SbbPersonaLink
      hideUrl={hideUrl}
      disabled={disabled}
      title={title || defaultTitle}
      subTitle={subTitle || ""}
      initials={user.initials}
      initialsColor={user.initialsColor}
      profileImage={user.profileImage}
      personnelNumber={user.personnelNumber}
      size={size}
    />
  );
};
